import { render, staticRenderFns } from "./index.vue?vue&type=template&id=97bc88b6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../data/code/fc/dpp/dppofficialwebsitev2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bc88b6",
  null
  
)

export default component.exports